import { getQrCodeData } from "../template/scanData"

import { customGetQrCodeData } from "../customization/scanData"

export const qrCodeConfigs = () => {

  let getData = getQrCodeData

  // console.log('customGetQrCodeData', typeof customGetQrCodeData)

  // if customization - must be function
  if (typeof customGetQrCodeData === "function") getData = customGetQrCodeData

  return {
    getData
  }

}